import { GET_SEMINAR_SPECIFICS, GET_SEMINAR } from '../constants';

const parseSeminars = (state, seminars) =>
  seminars.reduce(
    (acc, { entryId, seminarType }) => {
      const existingSeminar = acc[seminarType.slug];
      const newRecommendedSeminars = seminarType.recommendedSeminars
        ? seminarType.recommendedSeminars.map(recommendedSeminar => recommendedSeminar.entryId)
        : [];
      const recommendedSeminars =
        existingSeminar && existingSeminar.recommendedSeminars
          ? [...new Set(existingSeminar.recommendedSeminars.concat(newRecommendedSeminars))]
          : newRecommendedSeminars;

      return {
        ...acc,
        [seminarType.slug]: {
          ...existingSeminar,
          ...seminarType,
          seminarSpecifics: existingSeminar
            ? existingSeminar.seminarSpecifics && [...new Set(existingSeminar.seminarSpecifics.concat(entryId))]
            : [entryId],
          recommendedSeminars,
        },
      };
    },
    { ...state }
  );

export default (state = {}, action) => {
  switch (action.type) {
    case `${GET_SEMINAR}_PENDING`:
      return state;

    case `${GET_SEMINAR}_FULFILLED`: {
      const data = action.payload;
      const recommendedSeminars = data.reduce((arr, specific) => {
        if (specific.seminarType.recommendedSeminars) {
          return arr.concat(specific.seminarType.recommendedSeminars);
        }
        return arr;
      }, []);
      const newSeminars = parseSeminars(state, data);
      return {
        ...state,
        ...newSeminars,
        ...parseSeminars({ ...state, ...newSeminars }, recommendedSeminars),
      };
    }

    case `${GET_SEMINAR_SPECIFICS}_FULFILLED`: {
      const data = action.payload;
      const recommendedSeminars = data.reduce((arr, specific) => {
        if (specific.seminarType.recommendedSeminars) {
          return arr.concat(specific.seminarType.recommendedSeminars);
        }
        return arr;
      }, []);
      const newSeminars = parseSeminars(state, data);
      return {
        ...state,
        ...newSeminars,
        ...parseSeminars({ ...state, ...newSeminars }, recommendedSeminars),
      };
    }

    case `${GET_SEMINAR}_REJECTED`:
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/seminars.js